import React from 'react';
import i18n from '../../i18n/i18n.js';
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";

import './CheckoutPayment.css'; 

class CheckoutPayment extends React.Component {
  
  emptyFormData = {
    payment_method: null,
  };

  emptyFormErrors = {
    payment_method: '',
  };

  constructor(props) {
      super(props);
      
      this.state = {
        show: false,
        hiding: false,
        formData: { ...this.emptyFormData },
        formErrors: { ...this.emptyFormErrors },
        checkoutSummary: {},
    };
  }

  show(parent = null) {
    this.parent = parent;

    let { formData } = this.state;

    if (typeof formData.payment_method == 'undefined' || formData.payment_method === null)
    {
      formData.payment_method = parseInt(this.parent.state.paymentDeliveryMethods.payment_method_id);
    }

    this.setState({
      show: true, 
      checkoutSummary: this.parent.state, 
      formData: formData, 
      checkoutStepData: this.parent.checkoutStepData.step3
    });
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle(parent = null) {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show(parent);
    }
  }

  handle_change(event, formDataKey) {
    const formData = this.state.formData;

    formData[formDataKey] = event.target.value;

    this.setState({formData});
  }

  set_form_data(formData,callback)
  {
    this.setState({formData:formData},()=>{
      if(typeof callback=='function'){ callback(); }
    });
  }

  handle_submit(e) {
    e.preventDefault();
    this.hide();
  }

  set_from_data_from_step(step_name,form_data = {},callback = () => {}) {
    let { formData } = this.state;

    
    form_data.payment_method_id = parseInt(formData.payment_method);

    formData.values = {...form_data};

    this.setState({formData}, () => {
      this.parent.set_from_data_from_step(step_name,form_data,callback);

      //this.hide();
    });
  }

  render() {
    const {formData, formErrors, show, hiding, checkoutSummary } = this.state;

    if (!show) return '';
 
    return <div className={`container floating_container page_checkout page_checkout_payment ${hiding ? 'out' : ''}`}>
          <div className="content">
          
          <PageHeader parent_ref={this} no_close title={i18n.t('checkoutPayment')} />
          
          <div className='container_inner'>
            <form className="checkout_methods" onSubmit={(e) => this.handle_submit(e)}>

            {checkoutSummary.paymentDeliveryMethods.payment_methods_order.map(payment_method_id => {
              const payment_method = checkoutSummary.paymentDeliveryMethods.payment_methods[payment_method_id];
            //{Object.values(checkoutSummary.paymentDeliveryMethods.payment_methods).map((payment_method,index) => {
              
              return payment_method.selectable ? <div key={`payment_method_${payment_method.id}`} className={`field radio payment_method ${formErrors.payment_method !== '' ? "error" : ""}`}>
                  <div className="radio">
                    <input id={`payment_method_${payment_method.id}`} checked={parseInt(formData.payment_method) === parseInt(payment_method.id)} type="radio" name="payment_method" value={parseInt(payment_method.id)} onChange={(e) => this.handle_change(e, 'payment_method', {payment_method})} /> 
                    <label htmlFor={`payment_method_${payment_method.id}`} className="checkbox_radio_content"><p><b>{payment_method.payment_method}</b></p><p dangerouslySetInnerHTML={{__html: payment_method.payment_content}}></p></label>
                  </div> 
                </div> : '';
            })}

              {(formErrors.payment_method.length) ? <div className="form_error">{formErrors.payment_method}</div> : '' } 
            </form>
            
            {parseInt(formData.payment_method) !== 0 ? <button type="button" className="button" onClick={() => this.set_from_data_from_step('3')}>{i18n.t('checkoutSave')}</button> : ''}
          </div> 

          </div>
      </div>;
  }
}

export default CheckoutPayment;